export default __webpack_public_path__ + "static/media/settings-icon.e5edd079.svg";